import { QueryKey, useQuery, UseQueryResult } from 'react-query'

export type Props<T> = {
  key: QueryKey
  fetchFn: () => Promise<T>
  staleTime?: number
  enabled?: boolean
}

export default function useFetching<T>(props: Props<T>): UseQueryResult<T, unknown> {
  const { key, fetchFn, enabled = true, staleTime = 50 } = props
  const query = useQuery<T>(
    key,
    async function() {
      const response = await fetchFn()
      return response
    },
    {
      staleTime,
      enabled
    }
  )

  return query
}
